import React, { useCallback } from 'react';
import { GoBackButton } from '../../../../1_atoms/GoBackButton/GoBackButton';
import { Stepper } from '../../../../1_atoms/Stepper/Stepper';
import { SendFlowStep, useSendFlowContext } from '../../contexts/sendflow';
import { AmountScreen } from './components/AmountScreen';
import { InitialScreen } from './components/InitialScreen';
import { MainScreen } from './components/MainScreen';
import { ReviewScreen } from './components/ReviewScreen';
const allowedStepsToGoBackFrom = [
    SendFlowStep.MAIN,
    SendFlowStep.AMOUNT,
    SendFlowStep.REVIEW,
];
const getBackStep = (step) => {
    switch (step) {
        case SendFlowStep.MAIN:
            return SendFlowStep.INITIAL;
        case SendFlowStep.AMOUNT:
            return SendFlowStep.MAIN;
        case SendFlowStep.REVIEW:
            return SendFlowStep.AMOUNT;
        default:
            return SendFlowStep.AMOUNT;
    }
};
export const SendFlow = () => {
    const { set, step } = useSendFlowContext();
    const onBackClick = useCallback(() => {
        set(prevState => (Object.assign(Object.assign({}, prevState), { step: getBackStep(step) })));
    }, [set, step]);
    return (React.createElement(React.Fragment, null,
        step !== SendFlowStep.INITIAL && (React.createElement(GoBackButton, { onClick: onBackClick, disabled: !allowedStepsToGoBackFrom.includes(step) })),
        step !== SendFlowStep.INITIAL && (React.createElement(Stepper, { className: "mt-6", steps: 5, activeStep: step })),
        React.createElement("div", { className: "mt-0 md:mt-10" },
            step === SendFlowStep.INITIAL && React.createElement(InitialScreen, null),
            step === SendFlowStep.MAIN && React.createElement(MainScreen, null),
            step === SendFlowStep.AMOUNT && React.createElement(AmountScreen, null),
            [
                SendFlowStep.REVIEW,
                SendFlowStep.PROCESSING,
                SendFlowStep.COMPLETED,
            ].includes(step) && React.createElement(ReviewScreen, null))));
};
